import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Node } from 'reducers/nodesReducer';

type TEnableNodePopup = {
  node: Node;
  onClose: () => void;
  onSave: () => void;
};

export default function DisableNodePopup({ node, onClose, onSave }: TEnableNodePopup): React.ReactElement {
  return (
    <Modal show onHide={onClose}>
      <Modal.Header>
        <Modal.Title>
          Disabling node <strong>{node.aeTitle}</strong>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to disable this node?</p>
        <div style={{ textAlign: 'right' }}>
          <br />
          <Button onClick={onClose} variant="outline-secondary" style={{ marginRight: '5px' }}>
            Cancel
          </Button>
          <Button style={{ width: '8em' }} variant="danger" onClick={onSave}>
            Disable
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
